import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Paper,
  Text,
  Group,
  Button,
  SimpleGrid,
  Stack,
} from "@mantine/core";
import moment from "moment";
import { Page } from "../../layout/page";
import { useServerApi } from "../../hooks/userServerApi";
import QuizStatusBadge from "../../components/quiz/QuizStatusBadge";

const MyQuizzes = () => {
  const navigate = useNavigate();
  const [api] = useServerApi();
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await api.Quiz.getMyQuizzes();
      setQuizzes(res?.data ?? []);
      setLoading(false);
    };
    load();
  }, []);

  const getDisplayStatus = (quiz) => {
    const status = quiz.latestResult?.status;
    if (status === "PASSED") return "PASSED";
    if (status === "FAILED") return "FAILED";
    if (status === "IN_PROGRESS") return "IN_PROGRESS";
    return "NOT_STARTED";
  };

  return (
    <Page title="My Quizzes">
      {loading && <Text color="dimmed">Loading...</Text>}
      {!loading && !quizzes.length && (
        <Text color="dimmed">No quizzes assigned to you.</Text>
      )}

      <SimpleGrid cols={1} spacing="md">
        {quizzes.map((quiz) => {
          const status = getDisplayStatus(quiz);
          const passed = status === "PASSED";
          return (
            <Paper key={quiz._id} p="lg" withBorder radius="md">
              <Group position="apart" align="flex-start">
                <Stack spacing={4}>
                  <Group spacing="sm">
                    <Text weight={600} size="lg">
                      {quiz.title}
                    </Text>
                    <QuizStatusBadge status={status} />
                  </Group>
                  <Text size="sm" color="dimmed">
                    Deadline:{" "}
                    {quiz.deadline
                      ? moment(quiz.deadline).format("YYYY-MM-DD")
                      : "No deadline"}
                  </Text>
                  {quiz.documentsTotal > 0 && (
                    <Text size="sm" color="dimmed">
                      Documents: {quiz.documentsAcknowledged}/
                      {quiz.documentsTotal} acknowledged
                    </Text>
                  )}
                  {quiz.latestResult?.score != null && (
                    <Text size="sm">Last score: {quiz.latestResult.score}%</Text>
                  )}
                  {quiz.latestResult?.completedAt && (
                    <Text size="sm" color="dimmed">
                      Completed:{" "}
                      {moment(quiz.latestResult.completedAt).format("YYYY-MM-DD HH:mm")}
                    </Text>
                  )}
                </Stack>
                <Group>
                  {passed ? (
                    <Button
                      variant="outline"
                      onClick={() =>
                        navigate(`/consultant/myQuizzes/${quiz._id}/result`)
                      }
                    >
                      View Result
                    </Button>
                  ) : (
                    <Button
                      onClick={() =>
                        navigate(`/consultant/myQuizzes/${quiz._id}`)
                      }
                    >
                      {status === "IN_PROGRESS" ? "Continue" : "Open Quiz"}
                    </Button>
                  )}
                </Group>
              </Group>
            </Paper>
          );
        })}
      </SimpleGrid>
    </Page>
  );
};

export default MyQuizzes;
